export const Types = {
  ADD: "ADD",
  UPDATE: "UPDATE",
  REMOVE: "REMOVE",
  GET: "GET",
  SET_ITEM_TYPE: "SET_ITEM_TYPE",
};

const INITIAL_STATE = {
  itemTypeList: [],
  itemTypeListCount: 0,
  itemType: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        itemTypeList: action.payload.rows,
        itemTypeListCount: action.payload.count,
      };

    case Types.ADD:
      return {
        ...state,
        itemTypeList: action.payload.rows,
        itemTypeListCount: action.payload.count,
      };

    case Types.UPDATE:
      return {
        ...state,
        itemTypeList: action.payload.rows,
        itemTypeListCount: action.payload.count,
      };

    case Types.REMOVE:
      return {
        ...state,
        itemTypeList: action.payload.rows,
        itemTypeListCount: action.payload.count,
      };

    case Types.SET_ITEM_TYPE:
      return {
        ...state,
        itemType: {
          ...action.payload,
        },
      };

    default:
      return state;
  }
}

// creators
export function listItemType(data) {
  return {
    type: Types.GET,
    payload: data,
  };
}

export function addItemType(data) {
  return {
    type: Types.ADD,
    payload: data,
  };
}

export function alterItemType(data) {
  return {
    type: Types.SET_ITEM_TYPE,
    payload: data,
  };
}

export function updateItemType(data) {
  return {
    type: Types.UPDATE,
    payload: data,
  };
}

export function deleteItemType(data) {
  return {
    type: Types.REMOVE,
    payload: data,
  };
}
